"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var message = document.createElement("div");
    message.classList.add("notification", type);
    var titleText = document.createElement("h2");
    var text = document.createElement("p");
    titleText.className = "title";
    titleText.textContent = title;
    text.textContent = description;
    message.appendChild(titleText);
    message.appendChild(text);
    message.style.top = "".concat(posTop, "px");
    message.style.right = "".concat(posRight, "px");
    setTimeout(function() {
        message.style.display = "none";
    }, 2000);
    document.body.appendChild(message);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.89dbffdb.js.map
